// extracted by mini-css-extract-plugin
module.exports = {"customRichTextWidget":"rich-text-widget--customRichTextWidget--question-int","customRichTextEditor":"rich-text-widget--customRichTextEditor--question-int"};